import { Anchor, Badge, Button, Card, Flex, Grid, Tooltip } from '@mantine/core';
import { IconAward, IconChartLine, IconFile, IconHistory } from '@tabler/icons-react';
import { useState } from 'react';
import { useLocation, useParams } from 'react-router';
import SurveyStats from './SurveyStats';

const SurveyCard = ({ survey, stats }) => {
  const [open, setOpen] = useState(true);
  const { accountId, domainId } = useParams();
  const location = useLocation();

  let badges = [];

  if (survey.scope === 'web' && survey.recommenders) {
    const pagePerRecommenders = survey.recommenders.reduce((accu, recommender) => {
      if (accu[recommender.pageId] === undefined) {
        accu[recommender.pageId] = { page: recommender.page, recommenders: [] };
      }
      accu[recommender.pageId].recommenders.push(recommender);
      return accu;
    }, {});

    badges = Object.values(pagePerRecommenders).flatMap(({ page, recommenders }, index) => {
      const pageBadges = [
        <Badge key={`page-${index}`} variant="default">
          <IconFile size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
          <Anchor
            href={`#/accounts/${accountId}/domains/${domainId}/pages?page=${page.id}&type=recommenders`}
            size="xs"
          >
            {page.name}
          </Anchor>
        </Badge>,
      ];
      recommenders.forEach((recommender, rIndex) => {
        pageBadges.push(
          <Badge key={`rec-${index}-${rIndex}`} variant="default">
            <IconAward size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
            <Anchor
              href={`#/accounts/${accountId}/domains/${domainId}/pages/${recommender.pageId}/recommenders/${recommender.id}/details`}
              size="xs"
            >
              {recommender.name}
            </Anchor>
          </Badge>
        );
      });
      return pageBadges;
    });
  }

  return (
    <Card key={survey.id} mb="md" onClick={() => setOpen(!open)} withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid align="center">
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <Anchor href={`#${location.pathname}/${survey.id}/details`} fw={600} style={{ display: 'block' }}>
              {survey.name}
            </Anchor>
            <Flex gap="xs" wrap="wrap" mt="xs">
              {badges.length > 0 && { badges }}
              {survey.allowAnonymousAccess && <Badge variant="default">Public link</Badge>}
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(survey.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(survey.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <SurveyStats survey={survey} stats={stats} />
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 3 }}>
            <Flex justify="flex-end">
              <Button component="a" href={`#${location.pathname}/${survey.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
    </Card>
  );
};

export default SurveyCard;
